


























import { Location } from "vue-router";
import { defineComponent } from "@vue/composition-api";
import { Transaction } from "@teacherskaya/api-provider/dist/api/TransactionProvider";
import { $t } from "@/lib/helpers/i18nHelper";
import { formatMoney } from "@/lib/helpers/money";
import { formatDate } from "@/lib/helpers/time";
import { Dictionary } from "@/types";
import GoForward from "@/components/GoForward.vue";

export default defineComponent({
  name: "LastFiveTransactions",
  components: { GoForward },
  props: {
    transactions: { type: Array as () => Transaction[], required: true },
    userId: { type: String, required: true },
  },
  computed: {
    itemsList(): Dictionary<string[]> {
      return this.transactions.reduce(
        (out, transaction) => {
          const amount = formatMoney(transaction.amount, { withSymbol: false, withSign: true });
          const type = $t(transaction.type);
          const date = formatDate(transaction.time);

          out.amount.push(amount);
          out.type.push(type);
          out.date.push(date);
          out.id.push(transaction.id);
          return out;
        },
        {
          amount: [],
          type: [],
          id: [],
          date: [],
        } as Dictionary<string[]>
      );
    },
    count(): number {
      return this.transactions.length;
    },
    location(): Location {
      return {
        name: "transactions",
        query: { userId: this.userId },
      };
    },
  },
});
